import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full text-center">
        {/* Animated 404 Badge */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="relative inline-block mb-6"
        >
          <div className="absolute inset-0 bg-blue-100 rounded-full blur-2xl opacity-50 transform scale-150 animate-pulse" />
          <h1 className="relative text-9xl font-extrabold text-blue-600 tracking-widest font-mono">
            404
          </h1>
        </motion.div>

        {/* Messaging */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Page not found</h2>
          <p className="text-sm text-gray-500 mb-8 max-w-sm mx-auto leading-relaxed">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
          </p>
        </motion.div>

        {/* Buttons / Actions */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col sm:flex-row gap-3 justify-center"
        >
          <Link
            to="/"
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-3 rounded-xl transition-colors text-center shadow-sm"
          >
            Back to home
          </Link>
          <Link
            to="/book-service"
            className="flex-1 bg-white border border-gray-200 hover:border-gray-300 text-gray-700 text-sm font-medium py-3 rounded-xl transition-colors text-center"
          >
            Book a service
          </Link>
        </motion.div>

        {/* Back Link */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8"
        >
          <Link
            to="/contact"
            className="text-xs font-semibold text-blue-600 hover:text-blue-700 hover:underline transition"
          >
            Need help? Contact support →
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
